// src/components/DirectorSection.jsx
import React from 'react';
import '../styles/DirectorSection.css';
import directorImg from '../Assets/Images/shorony.jpg'; // Replace with actual image path

function DirectorSection() {
  return (
    <div className="director-section" id="director">
      
      <div className="director-text">
        <p className="intro">Dr. Rezwana Afrose Shorony</p>
        <h1 className="title">Our Respected Director</h1>
        <p className="statement">
          We believe in quality, integrity, and hard work. Our vision is to make Akij Insaf Ltd. a
          name that echoes with trust and excellence across the nation and beyond.
        </p>
        <p className="statement">
          With a dedicated team and a commitment to innovation, we aim to build a legacy that
          contributes to the prosperity of future generations.
        </p>
      </div>
      <div className="director-image-wrapper">
        <div className="image-circle">
          <img src={directorImg} alt="Director" className="director-img" />
        </div>
        <div className="director-name">
          <p><strong>Dr. Rezwana Afrose Shorony</strong><br />Director - Akij Insaf Ltd.</p>
        </div>
      </div>
    </div>
  );
}

export default DirectorSection;
